import * as React from 'react';

import * as styles from './LinkToFullVersion.css';

interface ILinkToFullVersionProps {
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const LinkToFullVersion: React.FC<ILinkToFullVersionProps> = ({ onClick }) => {
  return (
    <a href="/" className={styles['full-link']} data-testid="LinkToFullVersion" onClick={onClick}>
      Полная версия сайта
    </a>
  );
};
